import {
  GxIcon
} from '@garpix/garpix-web-components-react';
import {useStoreon} from 'storeon/react';
import { useNavigate } from 'react-router-dom';
import React, { FC } from 'react';
import 'react-responsive-modal/styles.css';
import { api } from '@/api';
import { StopIcon } from '../../assets';
import ModalLayout from '../ModalLayout';
import styles from './styles/index.module.scss';
import Button from '../Button';
import useRefreshPage from '../../hooks/useRefreshPage';
import {removeCookie} from '../../utils';
import {useSiteConfigurations} from '../../apps/Applications/hooks';

interface IModal403 {
  flag?: boolean;
}

const Modal403: FC<IModal403> = ({ flag=true }) => {
    const {dispatch} = useStoreon();
    let navigate = useNavigate();
    const siteConfigurations = useSiteConfigurations();

    const handleClickLogout = async () => {
        await api.auth.logout();
        dispatch('currentUser/save', { status: false });
        navigate(siteConfigurations.page_home)
        removeCookie('operatorAtcNumber')
    };
  const { refreshPage } = useRefreshPage();
  return (
    <ModalLayout size='sm_1' onClose={handleClickLogout} flag={flag}>
      <div className={styles['block']}>
        <GxIcon className={styles['block--icon']} src={StopIcon} />
        <h2 className={styles['block--title']}>Доступ запрещен</h2>
        <p className={styles['block--desc']}>Для получения доступа обратитесь к администратору системы</p>
      </div>
      <div className={styles['footer']}>
        <Button onClick={refreshPage} className={styles['footer--btn']} theme='btn--gray'>
          Обновить страницу
        </Button>
        <Button href='/' className={styles['footer--btn']} onClick={handleClickLogout} >
          Вернуться на главную
        </Button>
      </div>
    </ModalLayout>
  );
};

export default Modal403;